import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Checkbox, Stack } from '@fluentui/react';
import { useSelector } from 'react-redux';
import { useGetBoardElementsByBoardId } from '../../../../../../../hooks/services/sKPI/useOfBoard';

const DataserieAssociacionChecks = (props) => {
    const { _dataSeries: objBoardDataSerie } = useSelector((state) => state.reduxBoardDataSeries);
   
    const { 
        inputParam_BoardId = null,
        inputParam_DataSerieList = null,
        inputParam_OnCheckboxChange = null,
    } = props;

    const [boardElements, setBoardElements] = useState(null)
    useGetBoardElementsByBoardId(inputParam_BoardId, boardElements, setBoardElements)

    return (
        <>
        <Stack tokens={{ childrenGap: 10 }}>
            {
                boardElements && objBoardDataSerie && objBoardDataSerie.data && objBoardDataSerie.data.map((dataserie, index) => 
                    <Checkbox
                        key={index}
                        label={<div><div className='ps-1' style={{borderLeft: `10px solid ${boardElements.find(x => x.elementId === dataserie.elementId).htmlColor}`}}>{dataserie.variableName}</div></div>}
                        //checked={inputParam_DataSerieList.indexOf(index) !== -1}
                        checked={inputParam_DataSerieList.find(x => x.dataserieId === dataserie.dataserieId) !== undefined}
                        //onChange={(event) => inputParam_OnCheckboxChange(event, index)}
                        onChange={(event, checked) => inputParam_OnCheckboxChange(event, checked, dataserie)}
                    />
                )
            }
        </Stack>
    </>
    );
};

DataserieAssociacionChecks.propTypes = {
    inputParam_BoardId: PropTypes.number.isRequired,
    inputParam_DataSerieList: PropTypes.array.isRequired,
    inputParam_OnCheckboxChange: PropTypes.func.isRequired,
};

export default DataserieAssociacionChecks;

